export default __webpack_public_path__ + "static/media/landscape7.39bf1202.jpeg";